import type {Schedule} from '../types/domain'
import React, {useContext, useEffect, useState} from 'react'
import Grid2 from '@mui/material/Grid'
import BlindsSchedule from './BlindsSchedule'
import {CircularProgress} from '@mui/material'
import {ScheduleContext} from './ScheduleContext'
import {useLocation} from 'react-router-dom'

function BlindsScheduleRoute() {
  const {schedules} = useContext(ScheduleContext)
  const [selectedSchedule, setSelectedSchedule] = useState<Schedule | undefined>()
  const location = useLocation()
  const pathParts = location.pathname.split('/')
  const scheduleName = decodeURIComponent(pathParts[pathParts.length - 1])

  useEffect(() => {
    if (!selectedSchedule) {
      setSelectedSchedule(schedules.find(schedule => schedule.name === scheduleName))
    }
  }, [schedules, scheduleName, selectedSchedule])
  return (
    <>
      <Grid2 container>
        <Grid2 size={12}>
          {selectedSchedule ? <BlindsSchedule schedule={selectedSchedule}/> : <CircularProgress/>}
        </Grid2>
      </Grid2>
    </>
  )
}

export default BlindsScheduleRoute
